import { useEffect, useState } from "react";
import api from "@/lib/api";

// The store's gift card product handle, if Shopify has one published to this storefront.
// Fetched once per page load and shared by every caller.
let pending = null;

export function fetchGiftCardHandle() {
  if (!pending) {
    pending = api
      .get("/shopify/gift-card")
      .then(({ data }) => data?.id || null)
      .catch(() => null);
  }
  return pending;
}

export function useGiftCardHandle() {
  const [handle, setHandle] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchGiftCardHandle().then((h) => alive && setHandle(h));
    return () => {
      alive = false;
    };
  }, []);
  return handle;
}
